module.exports = "<div data-bounce1></div><div data-bounce2></div><div data-bounce3></div>\n";